module.exports = __webpack_public_path__ + "static/media/A genuine platform to sell.32dcd148.png";